import { cn } from "@/utils/cn";
import { memo } from "react";

interface SwapPlanAdjustmentIllustrationProps {
  className?: string;
}

export const SwapPlanAdjustmentIllustration = memo(function SwapPlanAdjustmentIllustration({
  className,
}: SwapPlanAdjustmentIllustrationProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="150"
      height="171"
      viewBox="0 0 150 171"
      fill="none"
      aria-hidden
      className={cn(className)}
    >
      <g filter="url(#swap-plan-adjustment-filter0)">
        <circle cx="75" cy="83.7324" r="67" stroke="#328DF5" strokeWidth="8" />
      </g>
      <g filter="url(#swap-plan-adjustment-filter1)">
        <circle
          cx="75"
          cy="83.7324"
          r="63"
          stroke="url(#swap-plan-adjustment-paint0)"
          strokeWidth="8"
        />
      </g>
      <circle cx="75" cy="83.7324" r="66" stroke="white" strokeWidth="2" />
      <g filter="url(#swap-plan-adjustment-filter2)">
        <ellipse
          cx="109.561"
          cy="137.275"
          rx="28"
          ry="8"
          transform="rotate(-34.7792 109.561 137.275)"
          fill="white"
        />
      </g>
      <g filter="url(#swap-plan-adjustment-filter3)">
        <ellipse
          cx="39.5613"
          cy="33.275"
          rx="28"
          ry="8"
          transform="rotate(-34.7792 39.5613 33.275)"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="swap-plan-adjustment-filter0"
          x="0"
          y="8.73242"
          width="150"
          height="150"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_239_1841" />
        </filter>
        <filter
          id="swap-plan-adjustment-filter1"
          x="4"
          y="12.7324"
          width="142"
          height="142"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_239_1841" />
        </filter>
        <filter
          id="swap-plan-adjustment-filter2"
          x="70.1104"
          y="104"
          width="78.9019"
          height="66.55"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="8" result="effect1_foregroundBlur_239_1841" />
        </filter>
        <filter
          id="swap-plan-adjustment-filter3"
          x="0.110352"
          y="0"
          width="78.9019"
          height="66.55"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="8" result="effect1_foregroundBlur_239_1841" />
        </filter>
        <linearGradient
          id="swap-plan-adjustment-paint0"
          x1="75"
          y1="20.7324"
          x2="75"
          y2="146.732"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A3C2FB" />
          <stop offset="1" stopColor="#617D95" />
        </linearGradient>
      </defs>
    </svg>
  );
});
